import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Button, CircularProgress, Typography } from "@mui/material";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import DownloadIcon from "@mui/icons-material/Download";
import axios from "axios";
import moment, { MomentInput } from "moment";
import Title from "../../custom/Title";
import { getStockReport } from "../../../services/Reports";
import useService from "../../../hooks/useService";

const HeaderContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  border-radius: 7px;
  margin-bottom: 20px;
  margin-top: 20px;
`;

const ComponentContainer = styled.div`
  height: calc(100vh - 64px);
  width: 100%;
  background-color: white;
  padding: 10px 15px 10px 15px;
`;

const CenterLoadingContainer = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const CalendarContainer = styled.div`
  height: calc(100% - 43px);
  width: 100%;
  overflow-y: auto;
`;

export const StockReport = () => {
  let sessionId: any = localStorage.getItem("sessionId")
  const [loading, setLoading] = useState(false)
  const [selectedDate, setSelectedDate] = useState<any>()
  const { execute } = useService()


  const handleDateClick = (data: any) => {
    setSelectedDate(data)
  }

  const downloadStockReport = async() => {
    try {
      setLoading(true)
      let date = moment(selectedDate.date as MomentInput).format('DD-MM-YYYY')
      const params = { 
        Date: date
      }
      console.log(params,'tresint')
      const { data } = await execute(() => getStockReport({params}))

      
      let fileUrl = data?.data?.url
      
      if(fileUrl) {
        window.open(fileUrl, '_blank')
      } else {
        alert('PVC Stock report not found!')
      }
      
      setLoading(false)
    } catch (error) {
      setLoading(false)
      console.error('error ::', error)
      alert('Unable to get PVC Stock report!')
    }
  }

  const headerContainer = () => {
    let todaysDate = moment(moment().format('YYYY-MM-DD'))
    let selectedData = moment(selectedDate?.dateStr)

    return (
      <HeaderContainer>
        <Button
          variant="contained"
          onClick={downloadStockReport}
          endIcon={<DownloadIcon />}
          disabled={!selectedDate || loading || selectedData.isSame(todaysDate)}
        >
          Download Report
        </Button>
      </HeaderContainer>
    )
  }

  const renderLoading = () => {
    return (
      <CenterLoadingContainer>
        <CircularProgress color="primary" />
      </CenterLoadingContainer>
    )
  }

  const renderContent = () => {
    let today = new Date();
    let offset = 5.5 * 60; // IST is UTC+5:30, so 5.5 hours in minutes
    let localTime = new Date(today.getTime() + (offset * 60 * 1000));
    let tomorrow = new Date(localTime);
    tomorrow.setDate(today.getDate() + 1);
    const disableFrom = tomorrow.toISOString().split("T")[0];

    return (
      <>
        <CalendarContainer>
          <FullCalendar
            buttonText={{ today: "Today" }}
            plugins={[dayGridPlugin, interactionPlugin]}
            validRange={{ end: disableFrom }}
            initialView="dayGridMonth"
            height="100%"
            selectable
            dragScroll={false}
            dateClick={handleDateClick}
          />
        </CalendarContainer>
      </>
    )
  }

  return (
    <>
    <Title style={{ textAlign: 'left', margin: '20px 10px 10px 10px', color: '#7f7d76' }}>Stock Report</Title>
      {headerContainer()}
      <ComponentContainer>
        {loading ? renderLoading() : renderContent()}
      </ComponentContainer>
    </>
  )
}

